export const cdn = process.env.NX_CDN_HOST;
export const CDN_UPLOADS_FOLDER = 'v3/uploads';
export const CDN_I18N_FOLDER = 'v3/i18n';

export const CDN_UPLOADS_PATH = `${cdn}/${CDN_UPLOADS_FOLDER}`;
export const CDN_I18N_PATH = `${cdn}/${CDN_I18N_FOLDER}`;

export function replaceCdnHost(src: string): string {
  return !src
    ? src
    : src
        .replace('https://edexfe-public.s3.amazonaws.com', process.env.NX_CDN_HOST)
        .replace('https://ex-staticpages.s3.amazonaws.com', process.env.NX_CDN_HOST)
        .replace('https://ex-cms.s3.amazonaws.com', process.env.NX_CDN_HOST)
        .replace('https://edexfe.s3.amazonaws.com', process.env.NX_CDN_HOST)
        .replace('https://s3.amazonaws.com/edexfe-public', process.env.NX_CDN_HOST)
        .replace('https://s3.amazonaws.com/staticpages', process.env.NX_CDN_HOST)
        .replace('https://s3.amazonaws.com/ex-cms', process.env.NX_CDN_HOST)
        .replace('https://s3.amazonaws.com/edexfe', process.env.NX_CDN_HOST)
        .replace('https://s3.amazonaws.com/exAttachments', `${process.env.NX_CDN_HOST}/exAttachments`)
        .replace('https://s3.amazonaws.com/edexfe-programs', `${process.env.NX_CDN_HOST}/edexfe-programs`);
}
